export class Parallax {
  private parallaxEls: HTMLElement[] = [];
  private currentParallaxEl: HTMLElement | null = null;
  private triggerEl: HTMLElement | null = null;
  private contentEl: HTMLElement | null = null;
  private speed: number;
  private ticking: boolean = false;
  private mediaQuery: MediaQueryList | null = null;
  private currentScale: number = 1;

  constructor(speed: number = 0.5) {
    this.speed = speed;

    const parallaxEls = document.querySelectorAll<HTMLElement>('.js-parallax');
    const trigger = document.querySelector<HTMLElement>('.js-parallax__trigger');
    const content = document.querySelector<HTMLElement>('.js-parallax__content');

    if (parallaxEls.length !== 2 || !trigger || !content) {
      return;
    }

    this.parallaxEls = Array.from(parallaxEls);
    this.triggerEl = trigger;
    this.contentEl = content;
    this.mediaQuery = window.matchMedia('(min-width: 768px)');

    this.updateCurrentParallaxEl();
    this.mediaQuery.addEventListener('change', () => {
      this.updateCurrentParallaxEl();
      this.adjustParallaxScale(); // メディア切り替え時にも調整
    });

    window.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', this.adjustParallaxScale.bind(this));
    window.addEventListener('load', this.adjustParallaxScale.bind(this));
    this.onScroll();
  }

  private updateCurrentParallaxEl() {
    if (!this.mediaQuery) {
      return;
    }

    this.currentParallaxEl = this.mediaQuery.matches ? this.parallaxEls[0] : this.parallaxEls[1];
  }

  private adjustParallaxScale() {
    if (!this.currentParallaxEl || !this.contentEl) {
      return;
    }

    const windowWidth = window.innerWidth;
    const contentHeight = this.contentEl.offsetHeight;
    const backgroundHeight = this.currentParallaxEl.offsetHeight;

    if (windowWidth <= 1093 && windowWidth >= 768 && backgroundHeight < contentHeight) {
      this.currentScale = contentHeight / backgroundHeight;
    } else {
      this.currentScale = 1;
    }

    this.applyTransform(0); // 初期位置で再適用
  }

  private onScroll = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateParallax();
        this.ticking = false;
      });
      this.ticking = true;
    }
  };

  private updateParallax() {
    if (!this.currentParallaxEl || !this.triggerEl || !this.contentEl) {
      return;
    }

    const triggerRect = this.triggerEl.getBoundingClientRect();
    const triggerTop = triggerRect.top + window.scrollY;
    const triggerBottom = triggerTop + this.triggerEl.offsetHeight;
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    if (scrollY + windowHeight < triggerTop || scrollY > triggerBottom) {
      return;
    }

    const contentHeight = this.contentEl.offsetHeight;
    const backgroundHeight = this.currentParallaxEl.offsetHeight * this.currentScale;
    const maxMove = backgroundHeight - contentHeight;

    const scrollInSection = scrollY + windowHeight - triggerTop;
    const sectionHeight = triggerBottom - triggerTop + windowHeight;
    const ratio = scrollInSection / sectionHeight;

    const moveY = Math.min(Math.max(ratio * maxMove * this.speed, 0), maxMove);

    this.applyTransform(moveY);
  }

  private applyTransform(translateY: number) {
    if (!this.currentParallaxEl) {
      return;
    }
    this.currentParallaxEl.style.transform = `scale(${this.currentScale}) translateY(-${translateY}px)`;
    this.currentParallaxEl.style.transformOrigin = 'top';
  }
}
